import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { GenerativeArt } from './GenerativeArt';
import { ChaosToOrderAnimation } from './ChaosToOrderAnimation';

export const Hero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden min-h-screen flex items-center bg-white dark:bg-gray-900">
      <div className="absolute inset-0 w-full h-full pointer-events-none">
        <GenerativeArt className="w-full h-full opacity-50 dark:opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/90 to-transparent dark:from-gray-900 dark:via-gray-900/90 dark:to-transparent/20"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            className="text-center lg:text-left"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-gray-900 dark:text-white leading-tight mb-6">
              {t('hero.greeting')}<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-500 to-blue-600 dark:from-cyan-400 dark:to-blue-500">
                {t('hero.name')}
              </span>
            </h1>
            
            <p className="text-xl text-gray-600 dark:text-gray-300 leading-relaxed mb-8 max-w-2xl mx-auto lg:mx-0">
              {t('hero.title')}
            </p>
            
            <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-4">
              <a
                href="/solutions#cortex-ai"
                className="inline-flex items-center justify-center bg-cyan-600 dark:bg-cyan-500 text-white font-bold px-8 py-4 rounded-xl hover:bg-cyan-700 dark:hover:bg-cyan-400 transition-all duration-300 shadow-lg shadow-cyan-500/25 hover:shadow-cyan-500/40 hover:-translate-y-1"
              >
                {t('hero.ctaContact')}
              </a>
              <a
                href="/solutions"
                className="inline-flex items-center justify-center bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white font-semibold px-8 py-4 rounded-xl hover:bg-gray-200 dark:hover:bg-gray-700 transition-all duration-300 border border-transparent dark:border-gray-700"
              >
                {t('hero.ctaAbout')}
              </a>
            </div>
            
            <div className="mt-10 flex items-center justify-center lg:justify-start gap-4 text-sm text-gray-500 dark:text-gray-400">
               <div className="flex -space-x-2">
                  {[1,2,3].map(i => (
                    <div key={i} className="w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700 border-2 border-white dark:border-gray-900"></div>
                  ))}
               </div>
               <p>{t('hero.socialProof')}</p>
            </div>
          </motion.div>

          <motion.div 
            className="relative hidden lg:block"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          >
            <ChaosToOrderAnimation />
          </motion.div>
        </div>
      </div>
    </section>
  );
};